av = window.av || {};
av.specialConf = { "mode": "normal", "panel": "show", "fontSize": "normal", "letterSpacing": "normal", "fontFamily": "normal", "specialColors": "normal", "images": "normal" };
!!localStorage.getItem("special") && (av.specialConf = JSON.parse(localStorage.getItem("special"))); //JSON.parse()/JSON.stringify()
/*
Нужно:
1) менять размер шрифта (до 200%)
2) менять межбуквенный интервал
3) менять межстрочный интервал (не требуют, да и чер с ним пока)
4) менять шрифт (sans/serif)
5) менять цветовую схему (Ч/Б, Б/Ч, темно-синий на голубом (#063462/#9dd1ff), коричневый на бежевом (#59422e/#f7f3d6), салатовый на коричневом (#a9dd38/#3b2716))
6) картинки поменять на блоки с alt

specialConf содержит:
    panel: show|hide - панель открыта, прикрыта - панель с подробными настроками (цвет, размер и пр.)
    mode: normal|special - задействовать ли выбранные настройки для слабовид. версии
    fontSize: normal|big|bigger|biggest - использовать для присвоения одноименного класса элементу html (font-big и пр.), отвечает за размер основного шрифта, от которого пляшуь остальные размеры
    letterSpacing: normal|big|bigger|biggest - использовать для присвоения одноименного класса элементу html (spacing-big и пр.), отвечает за расстояние между буквами
    fontFamily: normal|sans|serif - использовать для присвоения одноименного класса элементу html (spacing-big и пр.), отвечает за расстояние между буквами
    specialColors: normal|BW|WB|BB|BC|GB - black/white, white/black, blue/blue, brown/coffee, green/brown
    images: normal|none
*/

av.toggleSpecial = function (what, how) {
    what = what || false;
    if (!what) { return };
    how = how || "normal";
    av.specialConf[what] = how;
    localStorage.setItem("special", JSON.stringify(av.specialConf));
    av.redrawSpecial();
    if (what == "mode" && how == "special") {
        document.querySelector("button.toggle").focus();
    }
};
av.specialClick = function () {
    let whoami = this.id || false;
    switch (whoami) {
        case "font-sm":
            switch (av.specialConf.fontSize) {
                case "big":
                    av.toggleSpecial("fontSize", "normal");
                    break;
                case "bigger":
                    av.toggleSpecial("fontSize", "big");
                    break;
                case "biggest":
                    av.toggleSpecial("fontSize", "bigger");
                    break;
            }
            break;
        case "font-lg":
            switch (av.specialConf.fontSize) {
                case "normal":
                    av.toggleSpecial("fontSize", "big");
                    break;
                case "big":
                    av.toggleSpecial("fontSize", "bigger");
                    break;
                case "bigger":
                    av.toggleSpecial("fontSize", "biggest");
                    break;
            }
            break;
        case "letter-spacing-sm":
            switch (av.specialConf.letterSpacing) {
                case "big":
                    av.toggleSpecial("letterSpacing", "normal");
                    break;
                case "bigger":
                    av.toggleSpecial("letterSpacing", "big");
                    break;
                case "biggest":
                    av.toggleSpecial("letterSpacing", "bigger");
                    break;
            }
            break;
        case "letter-spacing-lg":
            switch (av.specialConf.letterSpacing) {
                case "normal":
                    av.toggleSpecial("letterSpacing", "big");
                    break;
                case "big":
                    av.toggleSpecial("letterSpacing", "bigger");
                    break;
                case "bigger":
                    av.toggleSpecial("letterSpacing", "biggest");
                    break;
            }
            break;
        case "sans":
            av.toggleSpecial("fontFamily", (av.specialConf.fontFamily == "sans" ? "normal" : "sans"));
            break;
        case "serif":
            av.toggleSpecial("fontFamily", (av.specialConf.fontFamily == "serif" ? "normal" : "serif"));
            break;
        case "BW":
            av.toggleSpecial("specialColors", (av.specialConf.specialColors == "BW" ? "normal" : "BW"));
            break;
        case "WB":
            av.toggleSpecial("specialColors", (av.specialConf.specialColors == "WB" ? "normal" : "WB"));
            break;
        case "BB":
            av.toggleSpecial("specialColors", (av.specialConf.specialColors == "BB" ? "normal" : "BB"));
            break;
        case "BC":
            av.toggleSpecial("specialColors", (av.specialConf.specialColors == "BC" ? "normal" : "BC"));
            break;
        case "GB":
            av.toggleSpecial("specialColors", (av.specialConf.specialColors == "GB" ? "normal" : "GB"));
            break;
        case "img_off":
            av.toggleSpecial("images", "none");
            break;
        case "img_on":
            av.toggleSpecial("images", "normal");
            break;
    }
}

av.redrawSpecial = function () {
    let html = document.querySelector("html");

    let panel = document.querySelector("#special-panel");
    if (!panel) {
        panel = document.createElement("div");
        panel.id = "special-panel", document.body.appendChild(panel);
        panel.style.bottom = `0px`;
        panel.innerHTML =
            `
            <div class="container">
            <button type="button" tabindex="0" class="toggle">Настройки вида сайта</button>
                <li>
                    <div>
                        <span>Размер шрифта</span>
                    </div>
                    <div>
                        <button type="button" id="font-sm" title="Уменьшить шрифт" tabindex="0">A-</button>
                        <button type="button" id="font-lg" title="Увеличить шрифт" tabindex="0">A+</button>
                    </div>
                </li>
                <li>
                    <div>
                        <span>Интервал</span>
                    </div>
                    <div>
                        <button type="button" id="letter-spacing-sm" title="Уменьшить межбуквенный интервал" tabindex="0">-</button>
                        <button type="button" id="letter-spacing-lg" title="Увеличить межбуквенный интервал" tabindex="0">+</button>
                    </div>
                </li>
                <li>
                    <div>
                        <span>Стиль шрифта</span>
                    </div>
                    <div>
                        <button type="button" id="sans" title="Использовать шрифт с засечками" tabindex="0">A</button>
                        <button type="button" id="serif" title="Использовать шрифт без засечек" tabindex="0">A</button>
                    </div>
                </li>
                <li>
                    <div>
                        <span>Цвет сайта</span>
                    </div>
                        <div>
                            <button type="button" id="BW" title="Использовать цветовую схему черное на белом" tabindex="0">Ц</button>
                            <button type="button" id="WB" title="Использовать цветовую схему белое на черном" tabindex="0">Ц</button>
                            <button type="button" id="BB" title="Использовать цветовую схему синее на голубом" tabindex="0">Ц</button>
                            <button type="button" id="BC" title="Использовать цветовую схему коричневое на бежевом" tabindex="0">Ц</button>
                            <button type="button" id="GB" title="Использовать цветовую схему зеленое на коричневом" tabindex="0">Ц</button>
                        </div>
                </li>
                <li>
                    <div>
                        <span>Изображения</span>
                    </div>
                    <div>
                        <button type="button" id="img_off" title="Отключить вывод изображений" tabindex="0">Выкл</button>
                        <button type="button" id="img_on" title="Включить вывод изображений" tabindex="0">Вкл</button>
                    </div>
                </li>
            </div>
        `;
        // кнопки:
        Array.from(panel.querySelectorAll("button")).forEach((e) => { e.addEventListener("click", av.specialClick); });
        document.querySelector("#special-panel .container>button").addEventListener("click", function () {
            av.toggleSpecial("panel", (av.specialConf.panel == "show" ? "hide" : "show"));
        });
        panel.querySelector(".container>button").focus();
    }

    av.specialConf.mode == "normal" ? (html.classList.remove("special-enabled"), setTimeout(() => { html.classList.remove("none-trancition") }, 300)) : (html.classList.add("special-enabled"), html.classList.add("none-trancition"));

    if (av.specialConf.panel == "show") {
        panel.classList.remove('down');
        panel.style.bottom = `0px`;
    } else {
        panel.classList.add('down');
        let styles = window.getComputedStyle(panel);
        panel.style.bottom = `calc(-${styles.height} + 40px)`;
    }

    html.classList.remove("font-big", "font-bigger", "font-biggest"), html.classList.add("font-" + av.specialConf.fontSize);
    html.classList.remove("spacing-big", "spacing-bigger", "spacing-biggest"), html.classList.add("spacing-" + av.specialConf.letterSpacing);
    html.classList.remove("family-sans", "family-serif"), html.classList.add("family-" + av.specialConf.fontFamily);
    html.classList.remove("BW", "WB", "BB", "BC", "GB"), html.classList.add(av.specialConf.specialColors);

    av.specialConf.fontSize == "normal" ? document.querySelector("#font-sm").classList.add("inactive") : document.querySelector("#font-sm").classList.remove("inactive");
    av.specialConf.fontSize == "biggest" ? document.querySelector("#font-lg").classList.add("inactive") : document.querySelector("#font-lg").classList.remove("inactive");

    av.specialConf.letterSpacing == "normal" ? document.querySelector("#letter-spacing-sm").classList.add("inactive") : document.querySelector("#letter-spacing-sm").classList.remove("inactive");
    av.specialConf.letterSpacing == "biggest" ? document.querySelector("#letter-spacing-lg").classList.add("inactive") : document.querySelector("#letter-spacing-lg").classList.remove("inactive");

    av.specialConf.images == "normal" ? document.querySelector("#img_on").classList.add("inactive") : document.querySelector("#img_on").classList.remove("inactive");
    av.specialConf.images == "none" ? document.querySelector("#img_off").classList.add("inactive") : document.querySelector("#img_off").classList.remove("inactive");

    Array.from(document.querySelectorAll(".instead-image")).forEach((e) => { e.remove(); });
    Array.from(document.querySelectorAll("img[data-display]")).forEach((e) => {
        e.style.display = e.getAttribute("data-display");
        e.removeAttribute("data-display", e.style.display);
    });
    if (av.specialConf.images == "none" && av.specialConf.mode == "special") {
        Array.from(document.querySelectorAll("img:not([data-display])"))
            .filter(x => !Array.from(x.classList).includes("show-always"))
            .forEach((e) => {
                let alttext = "Изображение без описания";
                e.hasAttribute("alt") && (alttext = "Изображение: " + e.getAttribute("alt"));

                let d = document.createElement("div");
                d.className = "instead-image";
                d.innerHTML = alttext;
                let cssObj = window.getComputedStyle(e);
                for (var i in cssObj) {
                    (cssObj.item(i).indexOf("font") === -1 && cssObj.item(i).indexOf("filter") === -1 && cssObj.item(i).indexOf("color") === -1 && cssObj.item(i).indexOf("background") === -1) && (d.style.setProperty(cssObj.item(i), cssObj.getPropertyValue(cssObj.item(i))));
                }
                d.style.border = "solid 1px";
                d.style.textAlign = "center";
                e.parentNode.insertBefore(d, e);

                e.setAttribute("data-display", e.style.display);
                e.style.display = 'none';
            });
    }
    av.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    }
    );
    [...document.querySelectorAll("a, input, button, .header__special-btn, .header__search-btn, .profile__name, .merch__name")].filter((el) => !el.hasAttribute("tabindex")).forEach(el => el.setAttribute("tabindex", 0))
};
window.onload = function () {
    document.querySelector("#specialButton").addEventListener("click", function () {
        av.toggleSpecial("mode", av.specialConf.mode == "normal" ? "special" : "normal")
    });
    document.querySelector("#specialButton").addEventListener("keydown", function (e) {
        if (e.key == "Enter" || e.key == "Spacebar" || e.key == " ") {
            e.preventDefault();
            av.toggleSpecial("mode", av.specialConf.mode == "normal" ? "special" : "normal")
        }
    });

    document.addEventListener("keyup", (e) => {
        console.log("active Element", document.activeElement);
    })

    av.redrawSpecial();
}

// При любом изменениии DOM:
av.mutationObserver = new MutationObserver(function (mutationsList) {
    // См. https://developer.mozilla.org/ru/docs/Web/API/MutationObserver
    av.mutationObserver.disconnect(); // Больше не смотрим на изменения
    av.redrawSpecial();
});

